import React from 'react';
import {
    Megaphone, Globe, DollarSign, MessageSquare, Calendar, MessageCircle, Layout, Search, Share2, Video,
    Users, GraduationCap, HeartHandshake, BookOpen, TrendingUp, Heart, FileQuestion, User, Phone,
    Target, Goal, Quote, Languages, Rocket, Settings, Headphones, IndianRupee
} from 'lucide-react';
import Text from '../components/Text';
import { Feature } from '../components/feature';
import LandingPageComponentWrapper from '../components/LandingPageComponentWrapper';
import Box from '../components/Box';
import { MarktingCard } from '../AvatarDigitalMarketer/AiMarketingTeam';
import Button from '../components/Button';
import AvatarCards from '../components/AvatarCards';
import History from 'constants/history';
import { Img } from 'components';
import { FlipText } from 'pages/NewLandingPage/HeroSection';
import { PATH } from 'utils';

const HeroTitleText = [
    {
        text: "Schools"
    }, {
        text: "Colleges"
    }
];


const features = [
    {
        icon: <Languages className="w-10 h-10 text-[#4949DE]" />,
        title: "Multilingual",
        description: "Language is no longer a barrier. Send messages in every parents language automatically.",
    },
    {
        icon: <Rocket className="w-10 h-10 text-[#4949DE]" />,
        title: "AI Growth Engine",
        description: "Drive admissions and revenue. AI handles visibility, marketing and parent engagement for you.",
    },
    {
        icon: <Users className="w-10 h-10 text-[#4949DE]" />,
        title: "Connect Every Parent",
        description: "Urban or rural— everyone stays informed. Clear communication for every area, every time.",
    },
    {
        icon: <Settings className="w-10 h-10 text-[#4949DE]" />,
        title: "Smart Operations",
        description: "Reduce Manual Workload by 80%. From reminders to reporting— AI manages your routine tasks.",
    },
    {
        icon: <Headphones className="w-10 h-10 text-[#4949DE]" />,
        title: "24/7 Virtual Helpdesk",
        description: "Instant support for parents. Answers queries, shares updates and reduces office load.",
    },
    {
        icon: <IndianRupee className="w-10 h-10 text-[#4949DE]" />,
        title: "Smart Fee System",
        description: "Collect fees effortlessly. Automated reminders, instant receipts, online payments, etc.",
    },
];

const ourVisionFeatures = [
    {
        icon: <Target className="w-10 h-10 text-[#4949DE]" />,
        title: "Our Vision",
        description: "To redefine Indian education with multilingual, intelligent AI that makes every school future-ready and every student’s learning experience stronger.",
    },
    {
        icon: <Goal className="w-10 h-10 text-[#4949DE]" />,
        title: "Our Mission",
        description: "To deliver simple, powerful AI solutions built for India  by removing operational hurdles, enhancing communication, and helping schools grow with confidence.",
    },
]

export const optionsforYourAiEmployee = [
    {
        id: 'digital-marketing',
        name: 'Digital Marketing',
        options: [
            { icon: Layout, text: 'Instant Responsive Website Developer', badge: null },
            { icon: Search, text: 'SEO Specialist', badge: null },
            { icon: Share2, text: 'Social Media Manager', badge: null },
            { icon: Video, text: 'Automated Reels & Video Generator', badge: null },
            { icon: Users, text: '24/7 Virtual Admission Counsellor', badge: null },
        ]
    },
    {
        id: 'teachers',
        name: 'Teachers',
        options: [
            { icon: GraduationCap, text: 'SuperStudent', badge: 'Coming soon' },
            { icon: HeartHandshake, text: 'Parent Helpdesk', badge: null },
            { icon: BookOpen, text: 'Child Care', badge: null },
            { icon: TrendingUp, text: '1st Rank', badge: null },
        ]
    },
    {
        id: 'operations',
        name: 'Operations',
        options: [
            { icon: Globe, text: 'Multilingual Communication', badge: null },
            { icon: DollarSign, text: 'Auto Fee Collection', badge: null },
            { icon: MessageSquare, text: 'Parental Feedback', badge: null },
            { icon: Calendar, text: 'AI-Daily Tasks', badge: null },
            { icon: MessageCircle, text: 'AI-Chat', badge: null },
        ]
    },
    {
        id: 'self-healing-support',
        name: 'Self-Healing Support',
        options: [
            { icon: Heart, text: 'Self Healer', badge: 'New' },
            { icon: FileQuestion, text: 'Record and Report', badge: null },
            { icon: User, text: 'Virtual Relationship Manager', badge: null },
            { icon: Phone, text: 'AI-WhatsApp Support', badge: null },
        ]
    }
];

const buttonPointsCard1 = [
    { icon: "", text: "School" },
    { icon: "", text: "Coaching Centres" },
    { icon: "", text: "Colleges" },
    { icon: "", text: "Universities" },
    { icon: "", text: "Multi-Branch Institutions" },
];

const persentageBar = [
    { title: "30%", desc: "Business Revenue Growth" },
    { title: "40%", desc: "Fee Collection Improvement" },
    { title: "80%", desc: "Reduction in Manual Tasks" },
    { title: "₹1-2L", desc: "Annual Operational Savings" }
];

const avatarCards = [
    {
        icon: Megaphone,
        title: "AI Marketing Team",
        description: "A 24/7 digital growth engine that builds strong online visibility through responsive websites, SEO, daily content, auto-reels, and continuous admission support.",
        iconColor: "text-blue-600",
        image: "images/new-landing-page/digitalMarketerPersonV2.png",
    },
    {
        icon: GraduationCap,
        title: "AI Teaching Team",
        description: "An AI-enhanced learning support system offering daily inspiration, help desks, child-care guidance, and rank-improvement assistance.",
        iconColor: "text-blue-600",
        image: "images/new-landing-page/teacherPersonV2.png",
    },
    {
        icon: Headphones,
        title: "AI Support System",
        description: "A smart support backbone delivering automatic issue resolution, performance monitoring, relationship management, and instant WhatsApp assistance.",
        iconColor: "text-blue-600",
        image: "images/new-landing-page/supportPersonV2.png",
    },
    {
        icon: Settings,
        title: "AI Operations System",
        description: "An intelligent operations layer that manages multilingual communication, analyses parental feedback, automates fee collection, and simplifies workflows.",
        iconColor: "text-blue-600",
        image: "images/new-landing-page/operatorPersonV2.png",
    },
    {
        icon: Rocket,
        title: "AI Startups Assistant",
        description: "A complete growth and compliance suite offering integrated AI systems, marketing toolkits, and CS/CA/legal assistance to help institutions scale confidently.",
        iconColor: "text-blue-600",
        image: "images/new-landing-page/startupPersonV2.png",
    }
];

interface NewHeroSectionProps {
    renderComponents?: any[];
    sectionRefs?: React.MutableRefObject<any[]>;
}

export default function NewHeroSection({ renderComponents, sectionRefs }: NewHeroSectionProps) {
        const [currentFeatureIndex, setCurrentFeatureIndex] = React.useState(0);

    
        React.useEffect(() => {
            let timeoutId;
    
            const cycleFeature = () => {
                setCurrentFeatureIndex((prev) => (prev + 1) % HeroTitleText.length);
                timeoutId = setTimeout(cycleFeature, 3000); // call again after 3 seconds
            };
    
            // start the first cycle
            timeoutId = setTimeout(cycleFeature, 3000);
    
            return () => clearTimeout(timeoutId); // cleanup on unmount
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [HeroTitleText.length]);
    return (
        <>
            <main className="p-12">
                {/* Hero Text */}
                <div className="flex justify-center mb-[1vh]">
                    {/* <button className="flex items-center gap-2 bg-[#F5F5FF] border-[1px] border-[#4949DE] text-[#4949DE] px-[2vh] py-[1vh] rounded-full font-semibold text-[1.6vh] md:text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        <Sparkles className='h-4' /> Funded and Collaborated by
                    </button> */}
                    <Text type="highlighter" label={"BUILT FOR BHARAT. POWERED BY AI"} />
                </div>
                <div className="flex justify-center">
                    <div className="container flex flex-col items-center text-center space-y-2">
                        <div className='relative text-center flex flex-col items-center md:hidden p-0 m-0'>
                            <h1 className="relative 
                                w-fit 
                                text-[7vh] md:text-3xl 
                                font-bold 
                                text-[#181818] 
                                font-inter 
                                not-italic 
                                leading-[100%] 
                                tracking-[-0.96px] m-0 p-0" style={{ fontFamily: 'Inter, sans-serif' }}>
                                <span className="text-[#EB4335]">India's</span>{' '}
                                <span className="text-gray-900">First Business Ecosystem for</span>
                            </h1>
                            <h1 className="relative 
                                w-fit 
                                text-[7vh] md:text-3xl 
                                font-bold 
                                text-[#181818] 
                                font-inter 
                                not-italic 
                                leading-[100%] 
                                tracking-[-0.96px] -mt-[1vh] p-0">
                                {/* <span className="text-gray-900">Business Ecosystem for </span> */}
                                <FlipText key={currentFeatureIndex}>
                                    <span className="text-[#8431D6]">
                                        {HeroTitleText[currentFeatureIndex]?.text}
                                    </span>
                                </FlipText>
                            </h1>
                        </div>
                        <div className="hidden md:block">
                            <h1 className="text-[7vh] md:text-3xl leading-tight font-bold" style={{ fontFamily: 'Inter, sans-serif' }}>
                                <span className="text-orange-500">India's</span>{' '}
                                First Business Ecosystem for <span className="text-[#8431D6]">Schools</span>
                            </h1>
                        </div>
                        <div className="relative w-fit">
                            <h2 className="text-center text-xs font-medium text-[#4C4C4C] md:text-xs" style={{ fontFamily: 'Instrument Sans, sans-serif' }}>
                                Enabling smooth communication in a multilingual country, simplifying operations, and helping institutions <br /> strengthen admissions and increase revenue.
                            </h2>
                        </div>
                    </div>
                </div>

                {/* CTA Section */}
                <div className="text-center mt-[2.5vh]">
                    <div className="flex items-center justify-center gap-6 md:flex-col md:justify-center">
                        <button className="relative flex items-center gap-2 bg-gradient-to-r from-[#E5542F] to-[#8431D6] text-[white] px-[2.5vh] py-[1.6vh] rounded-md font-semibold text-[1.8vh] shadow-lg md:text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
                            Book a live demo
                        </button>
                        <button className="flex items-center gap-2 border-3 border-blue-600 text-blue-600 px-[2.5vh] py-[1.2vh] rounded-md font-semibold text-[1.8vh] md:text-sm" style={{ fontFamily: 'Poppins, sans-serif', borderWidth: '3px' }}>
                            Explore our Ecosystem
                        </button>
                    </div>
                </div>

                <div className="flex flex-col items-center mt-[5vh] gap-2">
                    <h2 className="text-center text-sm font-medium text-[#4C4C4C] md:text-lg" style={{ fontFamily: 'Instrument Sans, sans-serif' }}>
                        BACKED BY & PARTNERED WITH GLOBAL LEADERS
                    </h2>
                    <Img
                        alt={"asdsdasd"}
                        src={`images/new-landing-page/patnersLogo.png`}
                        className="object-cover w-[35%] md:w-full"
                    />
                </div>
            </main>
            <LandingPageComponentWrapper bg={"bg-[#ECECF7]"}>
                <Feature
                    mainClasses='bg-[#ECECF7]'
                    title={"Inspired By Bharat’s Vision"}
                    description={"Across Bharat, institutions struggled with language barriers, low engagement, and manual workloads."}
                    imageAlt="Across Bharat"
                    imageQuery="images/new-landing-page/aboutUsMap.png"
                    imgClassNames='w-[90%] md:w-full'
                    cta={
                        <>
                            {/* Quote Box */}
                            <div className="bg-[#4949DE1A] border-l-4 border-[#8431D6]  p-6">
                                <p className="text-xs text-[#181818] italic font-medium" style={{ fontFamily: 'Instrument Sans, sans-serif' }}>
                                    "What if every parent could receive school communication in their own language — instantly, intelligently, and automatically?"
                                </p>
                            </div>

                            {/* Main Content */}
                            <div className="space-y-4 mb-6">
                                <Text
                                    type="description"
                                    label="This idea gave birth to SOOMUCH.AI, an AI-powered ecosystem built exclusively for Indian educational institutions."
                                    cName='text-xs font-semibold'
                                />

                                <div>
                                    <Text
                                        type="description"
                                        cName="text-sm text-[#636363] font-medium sm:text-xs sm:leading-5"
                                        label={
                                            <span>
                                                Inspired by Hon'ble Prime Minister Narendra Modi's vision of a multilingual India and the{' '}
                                                <span className="text-[#8431D6] font-semibold hover:underline">
                                                    BHASHINI initiative
                                                </span>, this question guided our journey.
                                            </span>
                                        }
                                    />
                                </div>

                                <div>
                                    <Text
                                        type="description"
                                        cName="text-sm text-[#636363] font-medium sm:text-xs sm:leading-5"
                                        label={
                                            <span>
                                                Today,{' '}
                                                <span className="text-[#8431D6] font-semibold hover:underline">
                                                    SOOMUCH.AI
                                                </span>
                                                {' '}empowers institutions across rural and urban India, elevating communication and optimizing operations.
                                            </span>
                                        }
                                    />
                                </div>

                                <Text
                                    type="description"
                                    label="We adopted global best practices in AI, automation, and digital communication, and customized them for the Indian education landscape."
                                />
                            </div>
                        </>
                    }
                />
            </LandingPageComponentWrapper>

            <LandingPageComponentWrapper bg={"bg-[#4949DE]"}>
                <Feature
                    mainClasses='bg-[#4949DE]'
                    title={<Text type="cardTitle" label={"Who We Serve"} cName='text-[white]' />}
                    description={<Text type="description" label={"Institutions seeking to enhance admissions, increase revenue, and strengthen parent communication."} cName='text-[white]' />}
                    rightSideElement={
                        <div className="flex flex-wrap md:justify-center items-center gap-2">
                            {buttonPointsCard1.map((section, index) => (
                                <div key={"buttonPointsCard1" + index} className="flex items-center gap-3 rounded-full bg-[#4949DE] border border-[white] px-2 py-1">
                                    <Text label={section.text} cName="text-[white] text-sm font-medium text-nowrap whitespace-nowrap" />
                                </div>
                            ))}
                        </div>
                    }
                />
            </LandingPageComponentWrapper>

            <LandingPageComponentWrapper>
                <Box
                    badge={"WHY US"}
                    title={"Everything a school needs- Powered by AI"}
                    leftBlock={
                        <div className='col-span-2 max-w-4xl mx-auto'>
                            <div className="grid grid-cols-2 md:grid-cols-1 gap-6">
                                {features.map((member, index) => <MarktingCard key={"features" + index} member={member} />)}
                            </div>
                            <div className="mt-8 text-center">
                                <Text cName='font-semibold text-xs text-[#4949DE]' label={"The best part is, it also offers a Startup Assistant which worth 25 Lakhs— a complete system that a school requires, from marketing and teaching to fee collection and legal tasks, with full-time AI assistants working automatically 24/7 365 days."} />
                            </div>
                        </div>
                    }
                />
            </LandingPageComponentWrapper>

            <LandingPageComponentWrapper bg={"bg-[#ECECF7]"}>
                <Box
                    badge={"WHY US"}
                    title={"The SOOMUCH.AI Ecosystem"}
                    description={"Designed for Schools. Powered by AI"}
                    leftBlock={
                        <div className='col-span-2'>
                            <div className="flex md:flex-col justify-center items-start flex-wrap gap-6 w-full">
                                {avatarCards.map((card, index) => <div key={"avatarCards" + index} className='self-stretch w-[30%] md:w-full'>
                                    <AvatarCards
                                        {...card}
                                    />
                                </div>)}
                            </div>
                        </div>
                    }
                />
            </LandingPageComponentWrapper>

            <LandingPageComponentWrapper>
                <Box
                    badge={"WHY US"}
                    title={"Our Vision and Mission"}
                    leftBlock={
                        <div className='col-span-2 space-y-6 max-w-4xl mx-auto'>
                            <div className="grid grid-cols-2 md:grid-cols-1 gap-6">
                                {ourVisionFeatures.map((member, index) => <MarktingCard key={"ourVisionFeatures" + index} member={member} />)}
                            </div>
                            <MarktingCard member={{
                                title: "Why it Matters",
                                description: "Education deserves technology that understands India — its languages, diversity, and aspirations. We’re here to make that future accessible to every institution.",
                                cName: "text-center"
                            }} />
                        </div>
                    }
                />
            </LandingPageComponentWrapper>

            <LandingPageComponentWrapper bg={"bg-[#4949DE]"}>
                <Box
                    badge={"WHY US"}
                    parentClass={"bg-[#4949DE] text-[white] p-12"}
                    leftBlock={
                        <div className='col-span-2'>
                            <div className="grid grid-cols-4 md:grid-cols-1 gap-6">
                                {persentageBar.map((item, index) => <div key={"persentageBar" + index} className='text-center space-y-4'>
                                    <Text type="cardTitle" label={item.title} cName='text-4xl text-[white] font-bold' />
                                    <Text type="description" label={item.desc} cName='text-sm text-[white]' />
                                </div>)}
                            </div>
                        </div>
                    }
                />
            </LandingPageComponentWrapper>

            <LandingPageComponentWrapper bg={"bg-[#ECECF7]"}>
                <Box
                    badge={"WHY US"}
                    title={"What We Aim to Build"}
                    leftBlock={
                        <div className='space-y-4'>
                            <Text
                                type="description"
                                label="SOOMUCH.AI is shaping the next era of Indian education — inspired by BHASINI, guided by national vision, and powered by intelligent automation. "
                            />
                            <Text
                                type="description"
                                label="To make every educational institution in Bharat future-ready with simple, multilingual, and intelligent AI that removes operational barriers and drives sustainable growth."
                            />
                            <Text
                                type="description"
                                label='“Education deserves technology that understands India — its languages, diversity, and aspirations.'
                                cName='font-medium text-[#4949DE]'
                            />
                        </div>
                    }
                    rightBlock={<div className="bg-[#4949DE1A] border-l-4 border-[#8431D6] p-6 self-stretch space-y-4">
                        <Quote className='w-10 h-10 text-[#4949DE]' />
                        <p className="text-[#181818] italic font-medium" style={{ fontFamily: 'Instrument Sans, sans-serif' }}>
                            “Within a month, our efficiency improved dramatically. We’re saving money, time, and our staff is happier. SOOMUCH.AI has been a game-changer."
                        </p>
                        <div>
                            <span className="text-sm font-bold italic">-Principal, CBSE School</span>
                        </div>
                    </div>}
                />
            </LandingPageComponentWrapper>

            <LandingPageComponentWrapper>
                <Box
                    badge={"TAKE THE NEXT STEP"}
                    leftBlock={
                        <div className='col-span-2 md:col-span-1 p-7 text-center space-y-7'>
                            <Text type={"cardTitle"} cName="text-balance text-4xl md:text-4xl sm:text-3xl font-semibold tracking-tight text-[#0C0C0C]" label={"Join the Movement"} />
                            <div>
                                <Text type="description" cName="text-center text-xs text-[#4D4D4D] text-pretty font-medium" label={"Hundreds of institutions across Bharat are transforming with SOOMUCH.AI."} />
                                <Text type="description" cName="text-center text-xs text-[#4D4D4D] text-pretty font-medium" label={"Be part of the change — let’s build the future of Indian education, together."} />
                                <Text type="description" cName="text-center mt-3 text-xs text-[#4949DE] text-pretty font-medium" label={"BUILT FOR BHARAT. POWERED BY AI. DRIVEN BY EDUCATION"} />
                            </div>
                            <div className='mt-8 space-y-4'>
                                <div className="flex md:flex-col justify-center items-center gap-6">
                                    <Button label='Book a Live Demo' type='gradient' />
                                    <Button handleSubmit={() => History.navigate(PATH.PATH_FOR_CONTACT_US)} label="Contact US" type='outlined' />
                                </div>
                            </div>
                        </div>
                    }
                />
            </LandingPageComponentWrapper>
        </>
    );
}